module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":"前データとの差"},"en":{"label":"Diff from previous"}}')
  delete Component.options._Ctor
}
